import { render } from "./GeoLink.vue?vue&type=template&id=066e0f38&scoped=true"
import script from "./GeoLink.vue?vue&type=script&lang=js"
export * from "./GeoLink.vue?vue&type=script&lang=js"

import "./GeoLink.vue?vue&type=style&index=0&id=066e0f38&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-066e0f38"

export default script